module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Medium.0a5198a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Medium.otf
// module id = 6QWv
// module chunks = 0